<template>
  <div
    class="flow-graph-wrap"
    :class="{ 'flow-graph-wrap--clickable': !fullscreen }"
    @click="onWrapClick"
  >
    <div class="flow-graph-canvas" ref="canvas"></div>
    <Modal
      v-if="!fullscreen"
      v-model="showFull"
      title="流程图"
      footer-hide
      width="960"
      class-name="flow-graph-full-modal"
    >
      <div ref="modal-canvas" class="flow-graph-modal-canvas"></div>
    </Modal>
  </div>
</template>

<script>
import LogicFlow from '@logicflow/core';
import '@logicflow/core/dist/index.css';
import '@logicflow/extension/dist/index.css';

import nodes from './editor/components/nodes/index';
import SubmitEdge from './editor/components/edges/submit';

function decorateGraphData(raw, statusMap) {
  if (!raw) return {nodes: [], edges: []};
  const map = statusMap || {};
  const nodes = (raw.nodes || []).map((n) => {
    const props = {...(n.properties || {})};
    if (map[n.id]) {
      props._execStatus = map[n.id];
    }
    return {...n, properties: props};
  });
  const edges = (raw.edges || []).map((e) => {
    const props = {...(e.properties || {})};
    const target = nodes.find((n) => n.id === (e.targetNodeId || e.to));
    if (target && (target.type === 'carbon_node' ||
      (target.graph && target.graph.type === 'carbon_node'))) {
      props._toCarbon = true;
    }
    if (e.properties && e.properties._toCarbon) {
      props._toCarbon = true;
    }
    return {...e, properties: props};
  });
  return {nodes, edges};
}

export default {
  data() {
    return {
      lf: null,
      lf_data: null,
      showFull: false,
      mlf: null,
    };
  },
  props: {
    data: {type: Object, default: null},
    /** { [nodeId]: 'done'|'rejected'|'pending'|'idle' } */
    statusMap: {type: Object, default: () => ({})},
    fullscreen: {type: Boolean, default: false},
  },
  watch: {
    data: {
      handler() {
        this.refreshData();
      },
      deep: true,
      immediate: true,
    },
    statusMap: {
      handler() {
        this.refreshData();
      },
      deep: true,
    },
  },
  mounted() {
    this.Init();
  },
  beforeDestroy() {
    this.lf = null;
    this.mlf = null;
  },
  methods: {
    refreshData() {
      this.lf_data = decorateGraphData(this.data, this.statusMap);
      if (this.lf) {
        this.lf.render(this.lf_data);
        this.$nextTick(() => {
          try {
            this.lf.translateCenter();
            this.lf.fitView(40, 40);
          } catch (e) { /* ignore */ }
        });
      } else {
        this.Init();
      }
      if (this.mlf && this.showFull) {
        this.mlf.render(this.lf_data);
        this.$nextTick(() => {
          try {
            this.mlf.translateCenter();
            this.mlf.fitView(80, 80);
          } catch (e) { /* ignore */ }
        });
      }
    },
    onWrapClick() {
      if (this.fullscreen) return;
      this.showFullModal();
    },
    showFullModal() {
      this.showFull = true;
      this.InitModal();
    },
    createLf(container, {silentMove = true} = {}) {
      const lf = new LogicFlow({
        container,
        width: container.clientWidth,
        height: container.clientHeight,
        background: {color: '#F5F7FA'},
        grid: {type: 'dot', size: 20},
        textEdit: false,
        isSilentMode: true,
        edgeType: 'approval-edge',
        stopScrollGraph: true,
        animation: true,
        snapline: true,
        stopMoveGraph: silentMove,
        adjustEdgeStartAndEnd: false,
        style: {rect: {radius: 6}},
      });
      nodes.forEach((n) => lf.register(n));
      lf.register(SubmitEdge);
      return lf;
    },
    InitModal() {
      this.$nextTick(() => {
        const container = this.$refs['modal-canvas'];
        if (!container) return;
        if (this.mlf) {
          this.mlf.render(this.lf_data);
          this.mlf.translateCenter();
          this.mlf.fitView(80, 80);
          return;
        }
        this.mlf = this.createLf(container, {silentMove: false});
        this.mlf.render(this.lf_data || {nodes: [], edges: []});
        this.mlf.translateCenter();
        this.mlf.fitView(80, 80);
      });
    },
    Init() {
      this.$nextTick(() => {
        const container = this.$refs.canvas;
        if (!container || container.clientHeight === 0 || container.clientWidth === 0) {
          return;
        }
        if (this.lf) {
          try {
            this.lf.destroy && this.lf.destroy();
          } catch (e) { /* ignore */ }
          this.lf = null;
        }
        this.lf = this.createLf(container, {silentMove: true});
        this.lf.render(this.lf_data || {nodes: [], edges: []});
        this.lf.translateCenter();
        this.lf.fitView(40, 40);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flow-graph-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #F5F7FA;
}
.flow-graph-wrap--clickable {
  cursor: zoom-in;
}
.flow-graph-canvas {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  pointer-events: none;
}
.flow-graph-modal-canvas {
  width: 100%;
  height: 640px;
  position: relative;
}
</style>
